import { render } from "./DueBadge.vue?vue&type=template&id=2f51d70e&scoped=true"
import script from "./DueBadge.vue?vue&type=script&lang=js"
export * from "./DueBadge.vue?vue&type=script&lang=js"

import "./DueBadge.vue?vue&type=style&index=0&id=2f51d70e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f51d70e"]])

export default __exports__